module.exports = __webpack_public_path__ + "static/media/down-app.png";